import { Event } from '../Event'
import { Identity } from '../../constants'

export interface UserLoggedInEventProperties {
  user_id: string
  context: 'sign-in-modal' | 'login' | 'login-challenge' | 'password-reset' | 'guest-checkout'
}

export class UserLoggedInEvent extends Event<UserLoggedInEventProperties> {
  static displayName = 'User Logged In'

  static allowedIdentities = [
    Identity.Guest,
    Identity.Consumer,
    Identity.BusinessUser,
    Identity.Operator,
  ]
}
